import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ArticlePath, createGuideLink, RouteName, TextKey } from '@mews-commander/enums';
import { RestrictionFormView } from '@mews-commander/modules/src/modules/restrictions';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Restriction/Create')({
    validateSearch: z.object({
        OwnerId: z.string().uuid(),
    }),
    beforeLoad: ({ context: { checkPrivilege } }) => {
        checkPrivilege('manageRestrictions');
    },
    component: Component,
    staticData: {
        title: TextKey.Restriction,
        routeName: RouteName.RestrictionCreate,
        owner: MewsTeam.RevenueServices,
        type: RouteType.Frontend,
        guideLink: createGuideLink(ArticlePath.ManagingRestrictions),
    },
});

function Component() {
    const { OwnerId: serviceId } = Route.useSearch();

    return <RestrictionFormView serviceId={serviceId} formType="createForm" />;
}
